<template>
  <div class="price-content">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="80px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="文件夹名称" prop="folderName">
          <el-input v-model.trim="searchForm.folderName" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="紧急程度" prop="emergency">
          <el-select v-model="searchForm.emergency" placeholder="全部" clearable @change="onSearch">
            <el-option label="紧急" value="1"></el-option>
            <el-option label="不紧急" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="picAdjustType">
          <el-select v-model="searchForm.picAdjustType" placeholder="全部" multiple collapse-tags clearable>
            <el-option label="新增" value="新增"></el-option>
            <el-option label="修改" value="修改"></el-option>
            <el-option label="删除" value="删除"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="adjustRemark">
          <el-input v-model.trim="searchForm.adjustRemark" placeholder="请输入" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="延期状态" prop="delayStatus">
          <el-select v-model="searchForm.delayStatus" clearable @change="onSearch">
            <el-option label="延期" value="1"></el-option>
            <el-option label="未延期" value="0"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
      </template>
    </search-box>

    <el-row class="tabs-row">
      <el-col :span="10">
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="tabs">
          <template v-if="storeTabs.length">
            <el-tab-pane
              v-for="(tab, index) in storeTabs"
              :key="index"
              :label="tab.label + ' ' + tab.count"
              :name="tab.name"
              :disabled="loading && tab.name != activeTab"
            ></el-tab-pane>
          </template>
          <div v-else class="occupy"></div>
        </el-tabs>
      </el-col>
      <el-col :span="14" class="table-btn-area">
        <el-button type="primary" size="mini" @click="handleProcessing(null)">批量已处理</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </el-col>
    </el-row>
    <table-panel ref="tablePanel">
      <vxe-table
        ref="multipleTable"
        :data="tableData.list"
        border
        stripe
        :height="maxTableHeight"
        v-loading="loading"
        @checkbox-change="handleSelectionChange"
        @checkbox-all="handleSelectionChange"
        :span-method="objectSpanMethod"
        :cell-style="cellStyle"
      >
        <vxe-column type="checkbox" width="55"></vxe-column>
        <vxe-column field="emergency" title="紧急程度" width="80"></vxe-column>
        <vxe-column field="folderName" title="文件夹名称" width="110" show-overflow></vxe-column>
        <vxe-column field="noticeTime" title="通知时间" width="160"></vxe-column>
        <vxe-column field="picAdjustType" title="类型" width="80" show-overflow></vxe-column>
        <vxe-column field="adjustDetailDesc" title="通栏图详情" width="100">
          <template #default="{ row }">
            <el-button v-if="row.adjustDetailDesc && row.adjustDetailDesc.length" size="mini" type="text" @click="viewImg(row.adjustDetailDesc)">
              查看
            </el-button>
          </template>
        </vxe-column>
        <vxe-column field="listContent" title="清单" min-width="60" show-overflow>
          <template #default="{ row }">
            <span
              v-if="row.listContent && row.listFileUrl"
              @click="handleDownload(row.listFileUrl, row.listContent)"
              style="color: #0bb78e; cursor: pointer"
            >
              {{ row.listContent }}
            </span>
            <span v-else>{{ row.listContent }}</span>
          </template>
        </vxe-column>
        <vxe-column field="adjustRemark" title="备注" min-width="200" show-overflow></vxe-column>
        <vxe-column field="sliceUrl" title="通栏图地址" min-width="200" show-overflow>
          <template #default="{ row }">
            <span v-copy="row.sliceUrl" style="color: #0bb78e; cursor: pointer">
              {{ row.sliceUrl }}
            </span>
          </template>
        </vxe-column>
        <vxe-column field="name" title="发布人" width="80"></vxe-column>
        <vxe-column field="creationDate" title="调整时间" width="160"></vxe-column>
        <vxe-column title="操作" width="80" align="center" fixed="right">
          <template #default="{ row }">
            <el-button type="text" @click="handleProcessing(row)">已处理</el-button>
          </template>
        </vxe-column>
      </vxe-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[100, 200, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <appeal-Review :visible.sync="isShowAppealReview" v-if="isShowAppealReview" :appealReason="appealReason" />
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
import appealReview from '../../components/appealReview';

export default {
  name: 'CannotProcessBannerContent',
  mixins: [tableMixin, pagePathMixin],
  components: { appealReview },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 100,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      selectedRows: [],
      searchForm: {
        folderName: '',
        picAdjustType: [],
        emergency: '',
        adjustRemark: '',
        delayStatus: '',
      },
      // 店铺标签页
      activeTab: undefined,
      storeTabs: [],
      reportName: 'waitUp',
      // 图片查看
      isShowAppealReview: false,
      appealReason: '',
    };
  },
  mounted() {
    let query = this.$route.query;
    if (query.activeTab == 'banner') {
      this.$set(this.searchForm, 'emergency', query.emergency || '');
      this.$set(this.searchForm, 'delayStatus', query.delayStatus || '');
    }
    this.getStroeTab();
  },
  methods: {
    getStroeTab() {
      this.loading = true;
      const data = new FormData();
      data.append('adjustContent', '通栏图');
      data.append('status', 4); // 暂缓处理状态
      this.$q.newProduct.storeStatics({ data: data }).then((res) => {
        this.storeTabs = res.data.map((v) => ({
          label: v.storeName,
          name: v.storeCode,
          count: v.qty,
        }));
        if (!this.storeTabs || !this.storeTabs.length) {
          this.loading = false;
          this.tableData.total = 0;
          this.tableData.list = [];
          return;
        }
        let tabs = this.storeTabs.map((v) => v.name);
        this.activeTab = this.activeTab == 0 || !tabs.includes(this.activeTab) ? this.storeTabs[0].name : this.activeTab;
        this.$nextTick((_) => {
          this.onSearch();
        });
      });
    },

    handleTabClick() {
      this.onSearch();
    },

    // 处理状态切换
    handleProcessStatusChange() {
      this.tableData.pageNum = 1;
      this.getStroeTab();
    },

    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let { folderName } = this.searchForm;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
          storeCode: this.activeTab,
          adjustContent: '通栏图',
          status: 4, // 暂缓处理状态
          folderName: folderName ? folderName.split(' ') : [],
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .msgNoticePage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.computeSpanData(res.data.list);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    onReset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1);
        this.spanIndex = 0;
      } else {
        if (data[index].folderName === data[index - 1].folderName) {
          this.spanArr[this.spanIndex] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.spanIndex = index;
        }
      }
    },
    objectSpanMethod({ rowIndex, column }) {
      return
      if (column.property == 'folderName') {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1,
        };
      }
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection.records || selection;
    },

    // 批量已处理
    handleProcessing(row) {
      if (this.selectedRows.length === 0 && !row) {
        this.$message.warning('请先选择商品！');
        return;
      }
      const stroeName = this.storeTabs.find((item) => item.name === this.activeTab).label;
      this.$confirm(`确认该商品在"${stroeName}"已处理吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const ids = row ? [row.id] : this.selectedRows.map((item) => item.id);
          let data = {
            status: 1,
            ids,
          };
          this.$q.newProduct.msgNoticeDeal({ data: data }).then((res) => {
            if (res.success) {
              this.$message.success(`${!row ? '批量' : ''}已处理成功`);
              this.getNewTab();
            }
          });
        })
        .catch(() => {});
    },

    getNewTab() {
      this.$emit('getNumber');
      this.getStroeTab();
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'fullWidthExport',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    cellStyle({ row, column }) {
      if (row.emergency == '紧急') {
        return {
          color: '#F56C6C',
        };
      }
      return {};
    },
    // 查看图片
    viewImg(appealReason) {
      this.isShowAppealReview = true;
      this.appealReason = appealReason;
    },
    // 下载文件（解决跨域下载问题）
    async handleDownload(url, fileName) {
      try {
        const loading = this.$loading({
          lock: true,
          text: '下载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        const response = await fetch(url);
        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
        loading.close();
      } catch (error) {
        this.$message.error('下载失败');
        console.error('下载失败:', error);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.price-content {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box {
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input {
    width: 240px !important;
  }
}

.tabs-row {
  margin-bottom: 5px;
}

.tabs {
  >>> .el-tabs__header {
    margin: 0 !important;
  }
}

.occupy {
  width: 200px;
  height: 20px
}

.table-btn-area {
  text-align: right;
  line-height: 40px;
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

  >>> .form-number-input .el-input-number {
      width: 105px !important;
  }
  >>> .form-number-input .el-input-number .el-input {
      width: 105px !important;
  }
</style>
